import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LayoutContainer from "../layout/LayoutContainer";
import Login from "../../../pages/Login/Login";
import Signup from "../../../pages/Login/Signup";
import FindUsername from "../../../pages/Login/FindUsername";
import FindPassword from "../../../pages/Login/FindPassword";
import History from "../../../pages/History/History";
import Summary from "../../../pages/Summary/Summary";
import Profile from "../../../pages/User/Profile";
import UserList from "../../../pages/User/Users";
import License from "../../../pages/License/License";
import Home from "../../../pages/Guide/Home";
import SarImport from "../../../pages/Sar/SarImport";
import SosGuide from "../../../pages/Guide/SosGuide";
import SarGuide from "../../../pages/Guide/SarGuide";
import Introduce from "../../../pages/Guest/Introduce";
import Detail from "../../../pages/Detail/Detail";
import GwReportGuide from "../../../pages/Guide/GwReportGuide";
import GwReport from "../../../pages/GwReport/GwReport";
import GwMHAGuide from "../../../pages/Guide/GwMHAGuide";
import MHAStatus from "../../../pages/MHAStatus/MHAStatus";
import GwDBHGuide from "../../../pages/Guide/GwDBHGuide";
import MariaDB from "../../../pages/DBHealth/MariaDB";
import MySQL from "../../../pages/DBHealth/MySQL";
import PostgreSQL from "../../../pages/DBHealth/PostgreSQL";
import WorkBookGuide from "../../../pages/Guide/WorkBookGuide";
import CmdExcelImport from "../../../pages/WorkBook/CmdExcel/CmdExcelImport";
import Error404 from "../../../pages/Error/Error404";
import Error500 from "../../../pages/Error/Error500";

const Navigator = () => {
  return (
    <Routes>
      {/* 에러 페이지 */}
      <Route path="/error404" element={<Error404 />} />
      <Route path="/error500" element={<Error500 />} />
      
      {/* 인증이 필요 없는 페이지들 */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/findusername" element={<FindUsername />} />
      <Route path="/findpassword" element={<FindPassword />} />
      {/* /contact 는 헬프데스크로 대체되어 제거했습니다. 문의·라이선스·견적은
          모두 헬프데스크에서 처리합니다. */}
      <Route path="/introduce" element={<Introduce />} />
      
      {/* Summary 페이지는 Layout 없이 독립적으로 렌더링 */}
      <Route path="/summary/:id" element={<Summary />} />
      
      {/* 나머지 페이지는 Layout으로 감싸기 */}
      <Route path="/" element={<LayoutContainer />}>
        <Route index element={<Navigate to="/home" replace />} />
        <Route path="home" element={<Home />} />
        <Route path="history" element={<History />} />
        <Route path="profile" element={<Profile />} />
        <Route path="userlist" element={<UserList />} />
        <Route path="license" element={<License />} />
        <Route path="sarimport" element={<SarImport />} />
        <Route path="sosguide" element={<SosGuide />} />
        <Route path="sarguide" element={<SarGuide />} />
        <Route path="detail" element={<Detail />} />
        
        <Route path="workbook" element={<WorkBookGuide />} />
        <Route path="cmdexcel" element={<CmdExcelImport />} />

        <Route path="rptguide" element={<GwReportGuide />} />
        <Route path="gwreport" element={<GwReport />} />
        <Route path="mhaguide" element={<GwMHAGuide />} />
        <Route path="mhastatus" element={<MHAStatus />} />
        <Route path="dbhguide" element={<GwDBHGuide />} />
        <Route path="mariadb" element={<MariaDB />} />
        <Route path="mysql" element={<MySQL />} />
        <Route path="postgresql" element={<PostgreSQL />} /> 
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default Navigator;
